import { render, staticRenderFns } from "./AuthScreen.vue?vue&type=template&id=60ee7fa6&"
import script from "./AuthScreen.vue?vue&type=script&lang=js&"
export * from "./AuthScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports